export default __webpack_public_path__ + "static/media/GPAY2.229ba406.png";